module.exports = __webpack_public_path__ + "static/media/examQuestion.24e36285.xlsx";